document.addEventListener('DOMContentLoaded', function () {
  const viewMoreBtn = document.getElementById('view-more-btn');
  const hiddenProducts = document.querySelectorAll('.view-more-hide');

  let isExpanded = false;

  viewMoreBtn.addEventListener('click', function () {
    if (!isExpanded) {
      hiddenProducts.forEach((product) => (product.style.display = 'flex'));
      viewMoreBtn.textContent = 'View Less';
    } else {
      hiddenProducts.forEach((product) => (product.style.display = 'none'));
      viewMoreBtn.textContent = 'View More';
    }
    isExpanded = !isExpanded;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const tabLinks = document.querySelectorAll('.tablinks');
  tabLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      // if (!e.target.classList.contains('arw')) return; feature use

      const tabName = link.getAttribute('data-tab');
      const content = document.getElementById(tabName);
      const isActive = link.classList.contains('active');

      document
        .querySelectorAll('.tabcontent, .mobile-content')
        .forEach((el) => {
          el.style.display = 'none';
        });
      tabLinks.forEach((l) => l.classList.remove('active'));
      document
        .querySelectorAll('.tabs-sec')
        .forEach((sec) => sec.classList.remove('active'));

      if (isActive) {
        return;
      }

      if (content) {
        content.style.display = 'block';
        content.scrollIntoView({ behavior: 'smooth' });
      }
      link.classList.add('active');
      if (link.parentElement) {
        link.parentElement.classList.add('active');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const productSection = document.querySelector('.products-we-offer-wrapper');

  if (productSection) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              productSection.classList.add('visible');
            }, 500);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      },
    );

    observer.observe(productSection);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const words = document.querySelectorAll('.word');
  const dots = document.querySelectorAll('.dot');
  const headingDuration = 1.0;
  const baseStart = headingDuration + 0.2;
  const step = 0.3; // delay between groups
  let groupIndex = 0;
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const isDot = word.classList.contains('dot');
    const text = word.getAttribute('data-word') || '';
    word.textContent = text;

    if (!isDot) {
      const dot = dots[groupIndex];
      const delay = baseStart + groupIndex * step;

      word.style.opacity = 0;
      word.style.animation = `fadeOnly 1.0s ease forwards`;
      word.style.animationDelay = delay + 's';

      if (dot) {
        dot.style.opacity = 0;
        dot.style.animation = `fadeInstant 1.0s linear forwards`;
        dot.style.animationDelay = delay + 's';
      }
      groupIndex++;
    }
  }
});
